import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import WorkPlace from '../Components/WorkEnvironment/WorkPlace'
import FlexAndConnectSection from '../Components/WorkEnvironment/FlexAndConnectSection'
import MobikodeWorkplaceSection from '../Components/WorkEnvironment/MobikodeWorkplaceSection'
import WelcomeHereSection from '../Components/WorkEnvironment/WelcomeHereSection'
import WorkingWithIntegritySection from '../Components/WorkEnvironment/WorkingWithIntegritySection'
import DesignedForBelongingSection from '../Components/WorkEnvironment/DesignedForBelongingSection'
import { Helmet } from "react-helmet-async";

function WorkEnvironment() {
  return (
    <div>
      <Helmet>
    <title>
        Work Environment at Mobikode | Culture, Collaboration & Inclusion
    </title>

    <meta
        name="description"
        content="Discover the work environment at Mobikode, where collaboration, flexibility, integrity, belonging, and meaningful connections create a positive workplace experience."
    />

    <meta
        name="keywords"
        content="Mobikode Work Environment, Work Environment, Mobikode Workplace, Workplace Culture, Work Culture, Employee Experience, Flexible Workplace, Workplace Collaboration, Inclusive Workplace, Workplace Belonging, Employee Engagement, IT Company Work Culture, Mobikode Culture"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/work-environment"
    />

    <meta
        property="og:title"
        content="Work Environment at Mobikode | Culture, Collaboration & Inclusion"
    />

    <meta
        property="og:description"
        content="Explore Mobikode's work environment built around collaboration, flexibility, integrity, inclusion, and a workplace where people can connect, contribute, and grow."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/work-environment"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/work/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Work Environment at Mobikode | Culture, Collaboration & Inclusion"
    />

    <meta
        name="twitter:description"
        content="Learn about the workplace culture at Mobikode and how flexibility, collaboration, integrity, and belonging shape the employee experience."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/work/bg1.png"
    />
</Helmet>
      <WhoHero
        title="Work-Enviroment"
        text="Technology. Transformation. Trust."
        imgData="/assets/work/bg1.png"
      />
      <WorkPlace />
      <FlexAndConnectSection />
      <MobikodeWorkplaceSection />
      <WelcomeHereSection />
      <WorkingWithIntegritySection />
      <DesignedForBelongingSection />
    </div>
  )
}

export default WorkEnvironment
